import { CCCookie } from './cc-cookie';
import { PilCookie } from './pil-cookie';

type TScenarioKeys = 'CCCookie' | 'PilCookie';
type TScenarioValues = typeof CCCookie | typeof PilCookie;

export const classes: Record<TScenarioKeys, TScenarioValues> = {
    CCCookie,
    PilCookie,
};
